const tag = {
    types: {
        SMALL: {
            fontType: 'Caption',
            containerPadding: '0.15625rem 0.375rem',
            labelPadding: '0.15625rem 0.125rem 0.15625rem 0.375rem',
            buttonPadding: '0.125rem 0.375rem 0.125rem 0.125rem',
        },
        MEDIUM: {
            fontType: 'Body',
            containerPadding: '0.25rem 0.5rem',
            labelPadding: '0.25rem 0.125rem 0.25rem 0.5rem',
            buttonPadding: '0.375rem 0.25rem 0.375rem 0.125rem',
        },
    },
};
export default tag;
//# sourceMappingURL=tag.js.map